(()=>{
 const wrap=document.getElementById('about-story'),stage=document.getElementById('aboutStoryStage');
 if(!wrap||!stage)return;
 const bg=stage.querySelector('.about-story-bg'),copy=stage.querySelector('.about-story-copy'),hint=stage.querySelector('.about-scroll'),cover=stage.querySelector('.about-reveal-cover'),aperture=stage.querySelector('#catideaApertureScale'),shade=stage.querySelector('.about-story-mask');
 const reduced=matchMedia('(prefers-reduced-motion:reduce)'),mobile=matchMedia('(max-width:940px)');let scheduled=false;
 const clamp=n=>Math.min(1,Math.max(0,n));const smooth=n=>{n=clamp(n);return n*n*(3-2*n)};
 function render(){
  scheduled=false;
  if(reduced.matches||mobile.matches){copy.style.opacity='1';copy.style.visibility='visible';copy.style.transform='none';bg.style.transform='none';shade.style.opacity='1';hint.style.opacity='0';return;}
  const top=parseFloat(getComputedStyle(stage).top)||0;
  const progress=clamp((top-wrap.getBoundingClientRect().top)/Math.max(1,wrap.offsetHeight-stage.offsetHeight));
  // Keep all pixels outside the letter apertures grey at entry. Enlarge the
  // aperture first; remove its remaining grey only near the end of the reveal.
  const expansion=clamp(progress/.64),scale=1+17*Math.pow(expansion,2.4);
  // The full-cover SVG stretches to the stage. Counter its vertical distortion
  // so the wordmark retains the proportions of a 1920x1080 viewport (75px header).
  const referenceStageRatio=1920/(1080-75);
  const stageRatio=stage.clientWidth/Math.max(1,stage.clientHeight);
  const scaleY=scale*stageRatio/referenceStageRatio;
  aperture.setAttribute('transform',`translate(800 450) scale(${scale.toFixed(5)} ${scaleY.toFixed(5)}) translate(-800 -450)`);
  cover.style.opacity=String(1-smooth((progress-.46)/.20));
  bg.style.transform=`scale(${1+smooth(progress)*.045})`;
  // Full image is visible from .66, leaving a distinct image-only interval.
  const text=smooth((progress-.76)/.18);
  copy.style.opacity=String(text);copy.style.visibility=text>0?'visible':'hidden';
  copy.style.transform=`translateY(${(1-text)*28}px)`;
  shade.style.opacity=String(smooth((progress-.69)/.20));
  hint.style.opacity=String(1-smooth(progress/.14));
 }
 function request(){if(!scheduled){scheduled=true;requestAnimationFrame(render)}}
 addEventListener('scroll',request,{passive:true});addEventListener('resize',request);
 reduced.addEventListener('change',request);mobile.addEventListener('change',request);render();
})();
